import React from 'react';
import {Box, Button, Stack, Typography} from '@mui/material';
import {useNavigate} from '@tanstack/react-router';
import {analytics, NewsPage} from '@resurs-internal/rb-app-api';
import {usePageView} from '../../../hooks';

const pageId = 'news-carousel';
export const NewsStep: React.FC<{step: NewsPage; handleClose?: () => void}> = ({
  step,
  handleClose,
}) => {
  const navigate = useNavigate();
  usePageView(pageId, step.title);

  const handleCtaClick = () => {
    const itemId = step.deeplinkId ?? step.announcementId ?? 'unknown';
    analytics.click({
      name: 'news_carousel_click_web',
      item_id: itemId,
      item_name: step.title,
      pageId: pageId,
    });
    if (step.link?.startsWith('http')) {
      window.open(step.link, '_blank');
    } else {
      navigate({to: step.link});
    }
    handleClose?.();
  };

  return (
    <>
      <Box
        sx={{
          display: 'inline-block',
          height: {md: '50%', xs: '40%'},
          width: '100%',
          clipPath: 'ellipse(100% 100% at 50% 0%)',
        }}>
        <Box
          component={'img'}
          src={step.imageUrl}
          alt="image_step_image"
          id="image_step_image"
          sx={{
            objectFit: 'cover',
            width: '100%',
            height: '100%',
          }}
        />
      </Box>

      <Stack p={4} textAlign={'center'}>
        <Typography variant={'h2'} mb={2} id={'image_step_title'}>
          {step.title}
        </Typography>
        <Typography
          id={'image_step_subtitle'}
          variant={'body1'}
          sx={(theme) => ({
            color: theme.palette.grey[600],
          })}>
          {step.subtitle}
        </Typography>
        {step.deeplinkText && step.link && (
          <Button
            variant={'contained'}
            id="image_step_button"
            sx={{minWidth: '200px', alignSelf: 'center', mt: 3}}
            onClick={handleCtaClick}>
            {step.deeplinkText}
          </Button>
        )}
      </Stack>
    </>
  );
};
